
  export const paymentStatusColor: Record<
    string,
    { bg: string; color: string }
  > = {
 
    PENDING: {
      bg: "#FFF7E6",
      color: "#D97706",
    },
    SUCCESS: {
      bg: "#E6F7F1",
      color: "#059669",
    },
    FAILED: {
      bg: "#FDECEC",
      color: "#DC2626",
    },
    PAID: {
      bg: "#E6F7F1",
      color: "#059669",
    },
    UNPAID: {
      bg: "#FDECEC",
      color: "#DC2626",
    },
  };